module.exports = __webpack_public_path__ + "img/page-networks-qrcode.f907c90f.png";